export default __webpack_public_path__ + "static/media/ESSS28LSIA01.43dd072c.mp4";